module.exports = __webpack_public_path__ + "static/media/darthvader.c94b7b6c.jpg";